import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useAuth } from "hooks";
import AuthService from "modules/Auth/services";
import ApiInstance from "util/Api";

export const useApp = () => {
  const { logout } = useAuth();
  const history = useHistory();

  const checkToken = async () => {
    if (ApiInstance.authToken) {
      const user = await AuthService.loadUser();
      if (!user) {
        logout();
        return;
      }
    }
  };

  useEffect(() => {
    checkToken();
    document.title = `Recalls`;
  }, []);

  useEffect(() => {
    ApiInstance.setHistory(history);
  }, [history]);
};
